import MobileFeatureCard from '../../components/mobile/MobileFeatureCard';
import MobileSearchBar from '../../components/mobile/MobileSearchBar';
import MobileInputs from '../../components/mobile/MobileInputs';
import { useSearchFields } from '../../SearchFieldProvider'; 
import MobileFeaturedEventCardCarousel from '../../components/mobile/MobileFeaturedEventCardCarousel';

export default function MobileHome({events}) {
    const {showModal} = useSearchFields();

     if (!showModal) {
        return (
            <div className="container py-3">
                <h3>Current Exhibitions</h3>
                <MobileFeatureCard/>
                <h3 className="pt-3">Featured Events</h3>
                <MobileFeaturedEventCardCarousel events={events}/>
                <nav className="navbar sticky-bottom" data-bs-theme="light">
                    <MobileSearchBar/>
                </nav>
            </div>
        );
     } else {
        return (
            <MobileInputs/>
        )
     };
    
}